import React, { useEffect } from "react";
import Routes from "./Routes";
import { initializeTheme } from "./utils/theme";

function App() {
  // Initialize theme on app mount
  useEffect(() => {
    initializeTheme();
  }, []);

  return (
    <Routes />
  );
}

export default App;
